export const buildRLink = (affUrl: string, offerUniqueId: string) => {
  try {
    const urlObject = new URL(affUrl);
    urlObject.pathname = `/r/${offerUniqueId}`;
    return urlObject.toString();
  } catch (error) {
    return affUrl;
  }
};

export const buildEntryLink = (domainLink: string, offerUniqueId: string) => {
  try {
    const urlObject = new URL(domainLink);
    urlObject.pathname = `/offer/${offerUniqueId}`;
    return urlObject.toString();
  } catch (error) {
    return domainLink;
  }
};

export const appendUidToUrl = (url: string, offerUniqueId: string) => {
  try {
    const urlObject = new URL(url);
    urlObject.searchParams.set('uid', offerUniqueId);
    return urlObject.toString();
  } catch (error) {
    return url;
  }
};
